import React from 'react';
import classNames from 'classnames';

import CheckedIcon from './icons/checked.svg';
import UncheckedIcon from './icons/unchecked.svg';

interface Props {
  className?: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
}

const MainCheckBox = ({ className, checked, onChange, id = '', disabled }: Props) => {
  const checkboxClasses = classNames('main-checkbox', className, {
    checked,
    disabled,
  });

  return (
    <span className={checkboxClasses}>
      <span className="main-checkbox-container">
        <input
          className="main-checkbox-input"
          id={id}
          type="checkbox"
          value=""
          onChange={onChange}
          data-indeterminate="false"
        />
        {checked ? <CheckedIcon /> : <UncheckedIcon />}
      </span>
    </span>
  );
};

export default MainCheckBox;
